export default {
  title: 'Histórico',
  summary: '{total} posição · retenção do plano: {days} dias | {total} posições · retenção do plano: {days} dias',
  all_devices: 'Todos os aparelhos',
  empty: 'Nenhuma posição no período.',
  table: {
    when: 'Quando',
    device: 'Aparelho',
    position: 'Posição',
    accuracy: 'Precisão',
    battery: 'Bateria',
    source: 'Origem',
  },
}
